import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteBookmark, deleteContentApi, deleteContentsApi } from '../../api/delete';
import { getContentApi } from '../../api/get';
import { updateContentsApi, updateContentApi } from '../../api/patch';
import { useCategory } from '../../CategoryContext';
import { Context } from '../../AuthContext';

function collectionToUrlSuffix(collection) {
  if (collection === 'papers') return 'publications';
  else if (collection === 'grants') return 'funding';
  else if (collection === 'authors' || collection === 'inventors' || collection === 'persons')
    return 'people';
  else return collection;
}

export function useDeleteContent() {
  const { updateCount } = useCategory();
  const { user } = useContext(Context);
  const navigate = useNavigate();

  const handleDelete = async ({
    id,
    collection,
    verticalId,
    parent_id = '',
    otherIds = [],
    bookmarked = false,
  }) => {
    if (!user) return;
    const token = await user.getIdToken();

    if (bookmarked) {
      await deleteBookmark({ id, vertical_id: verticalId, token });
    }

    if (collection === 'persons') {
      await deleteContentApi({ id, collection: 'people', vertical_id: verticalId, token });
      updateCount('people', -1);
    } else if (collection === 'papers' || collection == 'patents') {
      const linked_collection = collection === 'papers' ? 'authors' : 'inventors';
      let peopleToDelete = [];
      let peopleToUpdate = [];

      const people = await getContentApi({
        collection: linked_collection,
        vertical_id: verticalId,
        ids: otherIds,
        token,
      });

      let key = '';
      let identifier = '';

      if (collection === 'papers') {
        key = 'source_papers';
        identifier = 'authorId';
      } else {
        key = 'source_patents';
        identifier = 'name';
      }

      for (const person of people) {
        if (person[key].length === 1) {
          peopleToDelete.push(person[identifier]);
        } else {
          peopleToUpdate.push(person[identifier]);
        }
      }

      if (peopleToUpdate.length > 0)
        await updateContentsApi({
          collection: linked_collection,
          vertical_id: verticalId,
          ids: peopleToUpdate,
          parent_id: parent_id,
          token,
        });

      if (peopleToDelete.length > 0) {
        await deleteContentsApi({
          collection: linked_collection,
          vertical_id: verticalId,
          ids: peopleToDelete,
          token,
        });
        updateCount('people', -peopleToDelete.length);
      }

      await deleteContentApi({ id, collection, vertical_id: verticalId, token });
      updateCount(collection, -1);
    } else if (collection === 'authors' || collection === 'inventors') {
      await updateContentApi({ collection, id, vertical_id: verticalId, token });
      updateCount('people', -1);
    } else {
      await deleteContentApi({ id, collection, vertical_id: verticalId, token });
      updateCount(collection, -1);
    }

    navigate(`/vertical/${verticalId}/${collectionToUrlSuffix(collection)}`);
  };

  return { handleDelete };
}
